import React, {Component} from 'react';
import {withRouter} from "../../hoc/withRouter";
import {Breadcrumb, Col, Row, Input, Button, Checkbox, Form, Divider, Modal, Radio, Select, Slider, InputNumber, Space} from "antd";
import FooterSection from "../../component/pageSection/FooterSection";
import PageHeader from "../../component/header/PageHeader";
import {appDefaultArea} from "../../config/appDataConfig/appConfig";
import Cookies from "universal-cookie";
import {appName} from "../../config/appDataConfig/appConfig";
import "./formEvTaxi.css";
import {bqBridgingService} from "../../services/BqBridging/BqBridgingService";

const { Option } = Select;
const { TextArea } = Input;

// Daftar kota besar di Indonesia untuk dropdown searchable
const KOTA_LIST = [
    "Jakarta", "Surabaya", "Bandung", "Medan", "Semarang", "Makassar", "Palembang", 
    "Tangerang", "Depok", "Bekasi", "Bogor", "Malang", "Yogyakarta", "Solo", "Denpasar",
    "Batam", "Pekanbaru", "Balikpapan", "Samarinda", "Pontianak", "Manado", "Padang",
    "Banjarmasin", "Cirebon", "Tasikmalaya", "Sukabumi", "Serang", "Cilegon", "Karawang",
    "Purwokerto", "Tegal", "Pekalongan", "Kudus", "Magelang", "Surakarta", "Klaten",
    "Kediri", "Madiun", "Jember", "Banyuwangi", "Probolinggo", "Pasuruan", "Sidoarjo",
    "Gresik", "Mojokerto", "Blitar", "Tulungagung", "Mataram", "Kupang", "Ambon",
    "Jayapura", "Sorong", "Manokwari", "Ternate", "Gorontalo", "Palu", "Kendari",
    "Mamuju", "Pangkalpinang", "Tanjung Pinang", "Jambi", "Bengkulu", "Lampung",
    "Bandar Lampung", "Metro", "Cikarang", "Cibinong", "Serpong", "BSD", "Gading Serpong",
    "Alam Sutera", "Bintaro", "Cinere", "Cibubur", "Sentul", "Lainnya"
];

// Jabatan options
const JABATAN_OPTIONS = ["Owner", "Direktur", "Operasional", "Fleet", "Lainnya"];

class FormGreenTravel extends Component<any, any> {
    private cookies = new Cookies();
    private readonly initState!: any;
    private locationCheckInterval: any;

    constructor(props: any) {
        super(props);

        if (!this.cookies.get('_amc-a')) {
            this.cookies.set('_amc-a', appDefaultArea);
        }

        this.initState = {
            isDesktop: false,
            areaCode: (this.cookies.get('_amc-a')) ? this.cookies.get('_amc-a') : appDefaultArea,
            lat: this.cookies.get('_lat') || "",
            lng: this.cookies.get('_lng') || "",
            
            // A. Identitas & Kontak
            fullName: "",
            companyName: "",
            jabatan: null,
            whatsappNumber: "",
            email: "",
            kotaDomisili: null,
            kotaDomisiliLainnya: "",
            
            // B. Profil Operasional Travel
            jenisLayananTravelAntarKota: false,
            jenisLayananShuttleDalamKota: false,
            jenisLayananCharterSewaMobil: false,
            jenisLayananAntarJemputBandara: false,
            jenisLayananPariwisata: false,
            jenisLayananLainnya: false,
            jenisLayananLainnyaText: "",
            jumlahArmada: null,
            jenisArmadaMPV: false,
            jenisArmadaMinibus: false,
            jenisArmadaSUV: false,
            jenisArmadaSedan: false,
            jenisArmadaLainnya: false,
            rataRataTripPerHari: null,
            rataRataKmPerHari: null,
            
            // C. Rute yang Diminati
            ruteAsal: null,
            ruteTujuan: null,
            titikJemputUtama: "",
            titikTurunUtama: "",
            frekuensiKeberangkatan: null,
            jamFavoritPagi: false,
            jamFavoritSiang: false,
            jamFavoritSore: false,
            jamFavoritMalam: false,
            estimasiPenumpangPerHari: null,
            
            // D. Minat & Model Kerja Sama Limo Green
            tingkatMinat: 3,
            targetKebutuhanUnit: null,
            preferensiSkema: null,
            waktuMulaiOperasional: null,
            
            // E. Ekonomi & Preferensi Harga
            hargaTiketRataRata: null,
            rangeHargaTiketEV: null,
            biayaBBMPerBulan: null,
            masalahBiayaBBM: false,
            masalahBiayaPerawatan: false,
            masalahBiayaSupir: false,
            masalahBiayaDowntime: false,
            masalahBiayaKomisiPlatform: false,
            masalahBiayaLainnya: false,
            
            // F. Infrastruktur & Kesiapan EV
            aksesCharging: null,
            jenisChargingRumah: false,
            jenisChargingDepotPool: false,
            jenisChargingPublic: false,
            lokasiPoolUtama: "",
            kendalaCharging: false,
            kendalaDurasiCharge: false,
            kendalaRange: false,
            kendalaResaleValue: false,
            kendalaMaintenance: false,
            kendalaPembiayaan: false,
            kendalaEdukasiDriver: false,
            kendalaLainnya: false,
            kendalaLainnyaText: "",
            
            // G. Lead Qualification
            openDihubungi: null,
            waktuTerbaikDihubungi: null,
            catatanKhusus: "",
            
            // H. Consent
            consentSetuju: false,
            
            isSubmitting: false
        }
        this.state = {...this.initState}
    }

    handleResize = () => {
        if (window.innerWidth < 992) {
            this.setState({
                isDesktop: false,
            });
        } else {
            this.setState({
                isDesktop: true,
            });
        }
    }

    onAreaChange = async (data: any) => {
        this.cookies.set('_amc-a', data.city_group);
        await this.promisedSetState({
            areaCode: data.city_group,
        });
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 10);

        window.addEventListener("resize", this.handleResize.bind(this));
        this.handleResize();
        
        this.initLocationTracking();
        this.locationCheckInterval = setInterval(this.checkLocation, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
        if (this.locationCheckInterval) {
            clearInterval(this.locationCheckInterval);
        }
    }
    
    initLocationTracking = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    this.cookies.set('_lat', lat);
                    this.cookies.set('_lng', lng);
                    this.setState({ lat, lng });
                },
                (error) => {
                    console.error("Error obtaining location: ", error);
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    }
    
    checkLocation = () => {
        const lat = this.cookies.get('_lat');
        const lng = this.cookies.get('_lng');
        if (lat && lng && !this.state.lat) {
            this.setState({ lat, lng });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    onFieldChange = (field: string, value: any) => {
        const currentState: any = {...this.state}
        
        switch (field) {
            case "fullName":
                currentState.fullName = value;
                break;
            case "companyName":
                currentState.companyName = value;
                break;
            case "jabatan":
                currentState.jabatan = value;
                break;
            case "whatsappNumber":
                value = value.replace(/[^0-9]/g, '');
                if (value.length >= 2 && value.substring(0, 2) !== '08') {
                    value = value.substring(0, 1);
                }
                if (value.length > 13) {
                    value = value.substring(0, 13);
                }
                currentState.whatsappNumber = value;
                break;
            case "email":
                currentState.email = value;
                break;
            case "kotaDomisili":
                currentState.kotaDomisili = value;
                if (value !== "Lainnya") {
                    currentState.kotaDomisiliLainnya = "";
                }
                break;
            case "kotaDomisiliLainnya":
                currentState.kotaDomisiliLainnya = value;
                break;
            case "jenisLayananLainnyaText":
                currentState.jenisLayananLainnyaText = value;
                break;
            case "jumlahArmada":
                currentState.jumlahArmada = value;
                break;
            case "rataRataTripPerHari":
                currentState.rataRataTripPerHari = value;
                break;
            case "rataRataKmPerHari":
                currentState.rataRataKmPerHari = value;
                break;
            case "ruteAsal":
                currentState.ruteAsal = value;
                break;
            case "ruteTujuan":
                currentState.ruteTujuan = value;
                break;
            case "titikJemputUtama":
                currentState.titikJemputUtama = value;
                break;
            case "titikTurunUtama":
                currentState.titikTurunUtama = value;
                break;
            case "frekuensiKeberangkatan":
                currentState.frekuensiKeberangkatan = value;
                break;
            case "estimasiPenumpangPerHari":
                currentState.estimasiPenumpangPerHari = value;
                break;
            case "tingkatMinat":
                currentState.tingkatMinat = value;
                break;
            case "targetKebutuhanUnit":
                currentState.targetKebutuhanUnit = value;
                break;
            case "preferensiSkema":
                currentState.preferensiSkema = value;
                break;
            case "waktuMulaiOperasional":
                currentState.waktuMulaiOperasional = value;
                break;
            case "hargaTiketRataRata":
                currentState.hargaTiketRataRata = value;
                break;
            case "rangeHargaTiketEV":
                currentState.rangeHargaTiketEV = value;
                break;
            case "biayaBBMPerBulan":
                currentState.biayaBBMPerBulan = value;
                break;
            case "aksesCharging":
                currentState.aksesCharging = value;
                if (value !== "Ya") {
                    currentState.jenisChargingRumah = false;
                    currentState.jenisChargingDepotPool = false;
                    currentState.jenisChargingPublic = false;
                }
                break;
            case "lokasiPoolUtama":
                currentState.lokasiPoolUtama = value;
                break;
            case "kendalaLainnyaText":
                currentState.kendalaLainnyaText = value;
                break;
            case "openDihubungi":
                currentState.openDihubungi = value;
                break;
            case "waktuTerbaikDihubungi":
                currentState.waktuTerbaikDihubungi = value;
                break;
            case "catatanKhusus":
                currentState.catatanKhusus = value;
                break;
        }

        this.setState({
            ...currentState,
        });
    }

    onCheckboxChange = (field: string, checked: boolean) => {
        this.setState({
            [field]: checked
        });
    }

    validateEmail = (email: string) => {
        if (!email) return true; // Email opsional
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    validateForm = () => {
        let isValid = true;
        let errorMessage = "";

        // A. Identitas & Kontak
        if (!this.state.fullName) {
            isValid = false;
            errorMessage += "Nama lengkap, ";
        }
        if (!this.state.companyName) {
            isValid = false;
            errorMessage += "Nama perusahaan travel, ";
        }
        if (!this.state.jabatan) {
            isValid = false;
            errorMessage += "Jabatan, ";
        }
        if (!this.state.whatsappNumber || this.state.whatsappNumber.length < 10) {
            isValid = false;
            errorMessage += "Nomor WhatsApp (minimal 10 digit), ";
        }
        if (this.state.email && !this.validateEmail(this.state.email)) {
            isValid = false;
            errorMessage += "Format email tidak valid, ";
        }
        if (!this.state.kotaDomisili) {
            isValid = false;
            errorMessage += "Kota domisili usaha, ";
        }
        if (this.state.kotaDomisili === "Lainnya" && !this.state.kotaDomisiliLainnya) {
            isValid = false;
            errorMessage += "Kota domisili (lainnya), ";
        }

        // B. Profil Operasional Travel
        const anyJenisLayanan = this.state.jenisLayananTravelAntarKota || this.state.jenisLayananShuttleDalamKota || 
            this.state.jenisLayananCharterSewaMobil || this.state.jenisLayananAntarJemputBandara || 
            this.state.jenisLayananPariwisata || this.state.jenisLayananLainnya;
        if (!anyJenisLayanan) {
            isValid = false;
            errorMessage += "Jenis layanan (pilih minimal satu), ";
        }
        if (this.state.jenisLayananLainnya && !this.state.jenisLayananLainnyaText) {
            isValid = false;
            errorMessage += "Jenis layanan lainnya (keterangan), ";
        }
        if (!this.state.jumlahArmada || this.state.jumlahArmada < 1) {
            isValid = false;
            errorMessage += "Jumlah armada, ";
        }
        const anyJenisArmada = this.state.jenisArmadaMPV || this.state.jenisArmadaMinibus || 
            this.state.jenisArmadaSUV || this.state.jenisArmadaSedan || this.state.jenisArmadaLainnya;
        if (!anyJenisArmada) {
            isValid = false;
            errorMessage += "Jenis armada dominan (pilih minimal satu), ";
        }
        if (!this.state.rataRataTripPerHari) {
            isValid = false;
            errorMessage += "Rata-rata trip per hari, ";
        }
        if (!this.state.rataRataKmPerHari) {
            isValid = false;
            errorMessage += "Rata-rata km per hari per unit, ";
        }

        // C. Rute yang Diminati
        if (!this.state.ruteAsal) {
            isValid = false;
            errorMessage += "Rute asal, ";
        }
        if (!this.state.ruteTujuan) {
            isValid = false;
            errorMessage += "Rute tujuan, ";
        }
        if (!this.state.titikJemputUtama) {
            isValid = false;
            errorMessage += "Titik jemput utama, ";
        }
        if (!this.state.titikTurunUtama) {
            isValid = false;
            errorMessage += "Titik turun utama, ";
        }
        if (!this.state.frekuensiKeberangkatan) {
            isValid = false;
            errorMessage += "Frekuensi keberangkatan, ";
        }
        const anyJamFavorit = this.state.jamFavoritPagi || this.state.jamFavoritSiang || 
            this.state.jamFavoritSore || this.state.jamFavoritMalam;
        if (!anyJamFavorit) {
            isValid = false;
            errorMessage += "Jam favorit operasional (pilih minimal satu), ";
        }
        if (!this.state.estimasiPenumpangPerHari || this.state.estimasiPenumpangPerHari < 1) {
            isValid = false;
            errorMessage += "Estimasi penumpang per hari, ";
        }

        // D. Minat & Model Kerja Sama
        if (!this.state.targetKebutuhanUnit) {
            isValid = false;
            errorMessage += "Target kebutuhan unit, ";
        }
        if (!this.state.preferensiSkema) {
            isValid = false;
            errorMessage += "Preferensi skema, ";
        }
        if (!this.state.waktuMulaiOperasional) {
            isValid = false;
            errorMessage += "Waktu mulai operasional, ";
        }

        // E. Ekonomi & Preferensi Harga
        if (!this.state.hargaTiketRataRata || this.state.hargaTiketRataRata < 1) {
            isValid = false;
            errorMessage += "Harga tiket rata-rata, ";
        }
        if (!this.state.rangeHargaTiketEV) {
            isValid = false;
            errorMessage += "Range harga tiket untuk EV premium, ";
        }

        // F. Infrastruktur & Kesiapan EV
        if (!this.state.aksesCharging) {
            isValid = false;
            errorMessage += "Akses charging, ";
        }
        if (this.state.aksesCharging === "Ya") {
            const anyJenisCharging = this.state.jenisChargingRumah || this.state.jenisChargingDepotPool || 
                this.state.jenisChargingPublic;
            if (!anyJenisCharging) {
                isValid = false;
                errorMessage += "Jenis charging (pilih minimal satu), ";
            }
        }
        if (!this.state.lokasiPoolUtama) {
            isValid = false;
            errorMessage += "Lokasi pool utama, ";
        }

        // G. Lead Qualification
        if (!this.state.openDihubungi) {
            isValid = false;
            errorMessage += "Kesediaan dihubungi, ";
        }
        if (this.state.openDihubungi === "Ya" && !this.state.waktuTerbaikDihubungi) {
            isValid = false;
            errorMessage += "Waktu terbaik dihubungi, ";
        }

        // H. Consent
        if (!this.state.consentSetuju) {
            isValid = false;
            errorMessage += "Persetujuan penggunaan data, ";
        }

        return { isValid, errorMessage };
    }

    onSubmitForm = async () => {
        const { isValid, errorMessage } = this.validateForm();
        
        if (!isValid) {
            Modal.error({
                title: 'Proses Gagal',
                content: (<div>
                    Mohon Lengkapi data-data berikut: <br/><br/>
                    {errorMessage.split(",").map(function (itemError, i) {
                        return itemError.trim() ? <div key={i}>• {itemError.trim()}</div> : null;
                    })}
                </div>)
            });
            return;
        }

        // Collect service types
        const serviceTypes = [];
        if (this.state.jenisLayananTravelAntarKota) serviceTypes.push("INTERCITY_TRAVEL");
        if (this.state.jenisLayananShuttleDalamKota) serviceTypes.push("CITY_SHUTTLE");
        if (this.state.jenisLayananCharterSewaMobil) serviceTypes.push("CAR_CHARTER_RENTAL");
        if (this.state.jenisLayananAntarJemputBandara) serviceTypes.push("AIRPORT_TRANSFER");
        if (this.state.jenisLayananPariwisata) serviceTypes.push("TOURISM");
        if (this.state.jenisLayananLainnya) serviceTypes.push(`OTHER:${this.state.jenisLayananLainnyaText}`);

        // Collect fleet types
        const fleetTypes = [];
        if (this.state.jenisArmadaMPV) fleetTypes.push("MPV");
        if (this.state.jenisArmadaMinibus) fleetTypes.push("MINIBUS");
        if (this.state.jenisArmadaSUV) fleetTypes.push("SUV");
        if (this.state.jenisArmadaSedan) fleetTypes.push("SEDAN");
        if (this.state.jenisArmadaLainnya) fleetTypes.push("OTHER");

        // Collect preferred hours
        const preferredHours = [];
        if (this.state.jamFavoritPagi) preferredHours.push("MORNING");
        if (this.state.jamFavoritSiang) preferredHours.push("AFTERNOON");
        if (this.state.jamFavoritSore) preferredHours.push("EVENING");
        if (this.state.jamFavoritMalam) preferredHours.push("NIGHT");

        // Collect cost issues
        const costIssues = [];
        if (this.state.masalahBiayaBBM) costIssues.push("FUEL");
        if (this.state.masalahBiayaPerawatan) costIssues.push("MAINTENANCE");
        if (this.state.masalahBiayaSupir) costIssues.push("DRIVER");
        if (this.state.masalahBiayaDowntime) costIssues.push("DOWNTIME");
        if (this.state.masalahBiayaKomisiPlatform) costIssues.push("PLATFORM_COMMISSION");
        if (this.state.masalahBiayaLainnya) costIssues.push("OTHER");

        // Collect charging types
        const chargingTypes = [];
        if (this.state.jenisChargingRumah) chargingTypes.push("HOME");
        if (this.state.jenisChargingDepotPool) chargingTypes.push("DEPOT_POOL");
        if (this.state.jenisChargingPublic) chargingTypes.push("PUBLIC_CHARGING");

        // Collect EV concerns
        const evConcerns = [];
        if (this.state.kendalaCharging) evConcerns.push("CHARGING_ACCESS");
        if (this.state.kendalaDurasiCharge) evConcerns.push("CHARGING_DURATION");
        if (this.state.kendalaRange) evConcerns.push("RANGE");
        if (this.state.kendalaResaleValue) evConcerns.push("RESALE_VALUE");
        if (this.state.kendalaMaintenance) evConcerns.push("MAINTENANCE_SPAREPART");
        if (this.state.kendalaPembiayaan) evConcerns.push("FINANCING");
        if (this.state.kendalaEdukasiDriver) evConcerns.push("DRIVER_EDUCATION");
        if (this.state.kendalaLainnya) evConcerns.push(`OTHER:${this.state.kendalaLainnyaText}`);

        // Prepare data object with English keys
        const locationData = (this.state.lat && this.state.lng) ? {
            latitude: parseFloat(this.state.lat),
            longitude: parseFloat(this.state.lng)
        } : null;

        const formData: any = {
            // A. Identity & Contact
            contact_info: {
                full_name: this.state.fullName?.toUpperCase(),
                company_name: this.state.companyName?.toUpperCase(),
                position: this.state.jabatan,
                whatsapp_number: this.state.whatsappNumber,
                email: this.state.email?.toLowerCase() || null,
                business_city: this.state.kotaDomisili === "Lainnya" ? this.state.kotaDomisiliLainnya : this.state.kotaDomisili
            },
            
            // B. Operational Profile
            operational_profile: {
                service_types: serviceTypes,
                fleet_count: this.state.jumlahArmada,
                dominant_fleet_types: fleetTypes,
                avg_trips_per_day: this.state.rataRataTripPerHari,
                avg_km_per_day_per_unit: this.state.rataRataKmPerHari
            },
            
            // C. Route Interest
            route_interest: {
                origin_city: this.state.ruteAsal,
                destination_city: this.state.ruteTujuan,
                main_pickup_point: this.state.titikJemputUtama,
                main_dropoff_point: this.state.titikTurunUtama,
                departure_frequency: this.state.frekuensiKeberangkatan,
                preferred_operating_hours: preferredHours,
                estimated_passengers_per_day: this.state.estimasiPenumpangPerHari
            },
            
            // D. Interest & Partnership Model
            partnership_interest: {
                interest_level: this.state.tingkatMinat,
                target_unit_count: this.state.targetKebutuhanUnit,
                preferred_scheme: this.state.preferensiSkema,
                target_start_date: this.state.waktuMulaiOperasional
            },
            
            // E. Economics & Pricing Preference
            economics: {
                current_avg_ticket_price: this.state.hargaTiketRataRata,
                acceptable_ev_price_increase: this.state.rangeHargaTiketEV,
                current_monthly_fuel_cost_per_unit: this.state.biayaBBMPerBulan || null,
                major_cost_issues: costIssues
            },
            
            // F. Infrastructure & EV Readiness
            ev_readiness: {
                has_charging_access: this.state.aksesCharging,
                charging_types: this.state.aksesCharging === "Ya" ? chargingTypes : [],
                main_pool_location: this.state.lokasiPoolUtama,
                ev_concerns: evConcerns
            },
            
            // G. Lead Qualification
            lead_qualification: {
                open_to_contact: this.state.openDihubungi === "Ya",
                preferred_contact_time: this.state.waktuTerbaikDihubungi || null,
                special_notes: this.state.catatanKhusus || null
            },
            
            // H. Consent
            consent: {
                data_usage_agreed: this.state.consentSetuju
            },
            submitted_at: new Date().toISOString()
        };

        if (locationData) {
            formData.location = locationData;
        }

        // Set loading state
        this.setState({ isSubmitting: true });

        try {
            // Kirim data ke BqBridging menggunakan storeDataGreenTravel
            await bqBridgingService.storeDataGreenTravel(formData);
            
            // Console log seluruh data
            console.log("=== GREEN TRAVEL FORM DATA ===");
            console.log(JSON.stringify(formData, null, 2));
            console.log("==============================");
            
            // Reset form ke state awal
            this.setState({
                ...this.initState,
                areaCode: this.state.areaCode,
                lat: this.state.lat,
                lng: this.state.lng,
                isDesktop: this.state.isDesktop
            });

            // Tampilkan modal sukses
            Modal.success({
                title: 'Terima Kasih',
                content: (
                    <div>
                        <p>Data Anda telah berhasil disimpan.</p>
                        <p>Tim kami akan segera menghubungi Anda melalui WhatsApp untuk simulasi rute.</p>
                    </div>
                ),
                okText: 'Tutup',
                onOk: () => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
            });

        } catch (error) {
            Modal.error({
                title: 'Gagal Menyimpan Data',
                content: 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.'
            });
            console.error('Error submitting form:', error);
        } finally {
            this.setState({ isSubmitting: false });
        }
    }

    render() {
        const formItemStyle = {
            marginBottom: '15px'
        };

        const selectWrapperStyle = {
            width: '100%'
        };

        const sectionTitleStyle = {
            fontSize: '16px', 
            color: '#384967', 
            fontWeight: 500
        };

        return (
            <>
                <PageHeader black={true} onAreaChangeProps={this.onAreaChange} areaCode={this.state.areaCode} isDesktop={this.state.isDesktop}/>

                <Row className={`pt-100`}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <Breadcrumb className={`pl-20`}>
                            <Breadcrumb.Item>Amarta {appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>Form Limo Green Travel</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row className={`p-20 mt-20`} style={{backgroundColor: "#fff"}}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <div>
                            {/* Video Section */}
                            <div style={{
                                maxWidth: '720px',
                                margin: '0 auto 30px auto',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
                            }}>
                                <div style={{
                                    position: 'relative',
                                    width: '100%',
                                    paddingBottom: '56.25%' /* 16:9 Aspect Ratio */,
                                    height: 0,
                                    backgroundColor: '#000'
                                }}>
                                    <iframe
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            border: 'none'
                                        }}
                                        src="https://www.youtube.com/embed/6EIyM7qvis8"
                                        title="Limo Green Travel"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    />
                                </div>
                            </div>

                            <div style={{textAlign: "center", fontSize: "170%", marginBottom: 7}}>Pendaftaran Limo Green Travel</div>
                            <div style={{textAlign: "center", fontSize: "100%", marginBottom: 20, color: "gray"}}>Silakan isi data usaha travel Anda pada form di bawah ini</div>
                        </div>

                        <Form layout="vertical" className="ev-taxi-form">
                            
                            {/* A. Identitas & Kontak */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>A. Identitas & Kontak</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nama Lengkap *</i>
                                        <Input 
                                            value={this.state.fullName} 
                                            onChange={event => this.onFieldChange("fullName", event.target.value)} 
                                            placeholder="Masukan Nama Lengkap"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nama Perusahaan Travel *</i>
                                        <Input 
                                            value={this.state.companyName} 
                                            onChange={event => this.onFieldChange("companyName", event.target.value)} 
                                            placeholder="Masukan Nama Perusahaan Travel"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Jabatan *</i>
                                        <Select
                                            value={this.state.jabatan}
                                            onChange={value => this.onFieldChange("jabatan", value)}
                                            placeholder="Pilih Jabatan"
                                            style={{width: '100%'}}
                                        >
                                            {JABATAN_OPTIONS.map(item => (
                                                <Option key={item} value={item}>{item}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nomor WhatsApp *</i>
                                        <Input
                                            value={this.state.whatsappNumber}
                                            maxLength={13}
                                            placeholder="Format: 08xxxxxxxx"
                                            onChange={event => this.onFieldChange("whatsappNumber", event.target.value)}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Email (Opsional)</i>
                                        <Input
                                            value={this.state.email}
                                            placeholder="contoh@email.com"
                                            onChange={event => this.onFieldChange("email", event.target.value)}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Kota Domisili Usaha *</i>
                                        <Select
                                            showSearch
                                            value={this.state.kotaDomisili}
                                            onChange={value => this.onFieldChange("kotaDomisili", value)}
                                            placeholder="Pilih atau ketik kota"
                                            style={{width: '100%'}}
                                            filterOption={(input, option) =>
                                                (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {KOTA_LIST.map(kota => (
                                                <Option key={kota} value={kota}>{kota}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {this.state.kotaDomisili === "Lainnya" && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                        <Form.Item style={formItemStyle}>
                                            <i className={`text-small-grey-nopadding`}>Kota Domisili (Lainnya) *</i>
                                            <Input 
                                                value={this.state.kotaDomisiliLainnya} 
                                                onChange={event => this.onFieldChange("kotaDomisiliLainnya", event.target.value)} 
                                                placeholder="Masukan nama kota"
                                                style={{width: '100%'}}
                                            />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>

                            {/* B. Profil Operasional Travel */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>B. Profil Operasional Travel</span>
                            </Divider>
                            
                            <Row style={{marginBottom: '15px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Jenis Layanan (pilih yang sesuai) *</i>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisLayananTravelAntarKota', e.target.checked)} 
                                        checked={this.state.jenisLayananTravelAntarKota}
                                    >
                                        Travel Antar Kota
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisLayananShuttleDalamKota', e.target.checked)} 
                                        checked={this.state.jenisLayananShuttleDalamKota}
                                    >
                                        Shuttle Dalam Kota
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisLayananCharterSewaMobil', e.target.checked)} 
                                        checked={this.state.jenisLayananCharterSewaMobil}
                                    >
                                        Charter / Sewa Mobil
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisLayananAntarJemputBandara', e.target.checked)} 
                                        checked={this.state.jenisLayananAntarJemputBandara}
                                    >
                                        Antar-jemput Bandara
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisLayananPariwisata', e.target.checked)} 
                                        checked={this.state.jenisLayananPariwisata}
                                    >
                                        Pariwisata
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisLayananLainnya', e.target.checked)} 
                                        checked={this.state.jenisLayananLainnya}
                                    >
                                        Lainnya
                                    </Checkbox>
                                </Col>
                                {this.state.jenisLayananLainnya && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Input 
                                            value={this.state.jenisLayananLainnyaText} 
                                            onChange={event => this.onFieldChange("jenisLayananLainnyaText", event.target.value)} 
                                            placeholder="Sebutkan jenis layanan lainnya"
                                            style={{width: '100%'}}
                                        />
                                    </Col>
                                )}
                            </Row>

                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Jumlah Armada Saat Ini *</i>
                                        <InputNumber 
                                            value={this.state.jumlahArmada} 
                                            onChange={value => this.onFieldChange("jumlahArmada", value)} 
                                            placeholder="Masukan jumlah armada"
                                            min={1}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row style={{marginBottom: '15px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Jenis Armada Dominan *</i>
                                </Col>
                                <Col xl={{span: 4}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisArmadaMPV', e.target.checked)} 
                                        checked={this.state.jenisArmadaMPV}
                                    >
                                        MPV
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 4}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisArmadaMinibus', e.target.checked)} 
                                        checked={this.state.jenisArmadaMinibus}
                                    >
                                        Minibus
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 4}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisArmadaSUV', e.target.checked)} 
                                        checked={this.state.jenisArmadaSUV}
                                    >
                                        SUV
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 4}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisArmadaSedan', e.target.checked)} 
                                        checked={this.state.jenisArmadaSedan}
                                    >
                                        Sedan
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 4}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jenisArmadaLainnya', e.target.checked)} 
                                        checked={this.state.jenisArmadaLainnya}
                                    >
                                        Lainnya
                                    </Checkbox>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Rata-rata Trip Per Hari *</i>
                                        <Select
                                            value={this.state.rataRataTripPerHari}
                                            onChange={value => this.onFieldChange("rataRataTripPerHari", value)}
                                            placeholder="Pilih rata-rata trip"
                                            style={{width: '100%'}}
                                        >
                                            <Option value="1-2">1–2 trip</Option>
                                            <Option value="3-5">3–5 trip</Option>
                                            <Option value="6-10">6–10 trip</Option>
                                            <Option value=">10">&gt;10 trip</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Rata-rata KM Per Hari Per Unit *</i>
                                        <Select
                                            value={this.state.rataRataKmPerHari}
                                            onChange={value => this.onFieldChange("rataRataKmPerHari", value)}
                                            placeholder="Pilih rata-rata km"
                                            style={{width: '100%'}}
                                        >
                                            <Option value="<100">&lt;100 km</Option>
                                            <Option value="100-200">100–200 km</Option>
                                            <Option value="200-300">200–300 km</Option>
                                            <Option value=">300">&gt;300 km</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* C. Rute yang Diminati */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>C. Rute yang Diminati</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Rute Asal (Kota/Area) *</i>
                                        <Select
                                            showSearch
                                            value={this.state.ruteAsal}
                                            onChange={value => this.onFieldChange("ruteAsal", value)}
                                            placeholder="Pilih atau ketik kota asal"
                                            style={{width: '100%'}}
                                            filterOption={(input, option) =>
                                                (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {KOTA_LIST.map(kota => (
                                                <Option key={kota} value={kota}>{kota}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Rute Tujuan (Kota/Area) *</i>
                                        <Select
                                            showSearch
                                            value={this.state.ruteTujuan}
                                            onChange={value => this.onFieldChange("ruteTujuan", value)}
                                            placeholder="Pilih atau ketik kota tujuan"
                                            style={{width: '100%'}}
                                            filterOption={(input, option) =>
                                                (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {KOTA_LIST.map(kota => (
                                                <Option key={kota} value={kota}>{kota}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Titik Jemput Utama di Kota Asal *</i>
                                        <Input 
                                            value={this.state.titikJemputUtama} 
                                            onChange={event => this.onFieldChange("titikJemputUtama", event.target.value)} 
                                            placeholder="Contoh: Terminal Pulogadung, Mall X"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Titik Turun Utama di Kota Tujuan *</i>
                                        <Input 
                                            value={this.state.titikTurunUtama} 
                                            onChange={event => this.onFieldChange("titikTurunUtama", event.target.value)} 
                                            placeholder="Contoh: Stasiun Gambir, Bandara X"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Frekuensi Keberangkatan Rute Ini *</i>
                                        <Select
                                            value={this.state.frekuensiKeberangkatan}
                                            onChange={value => this.onFieldChange("frekuensiKeberangkatan", value)}
                                            placeholder="Pilih frekuensi"
                                            style={{width: '100%'}}
                                        >
                                            <Option value="Harian">Harian</Option>
                                            <Option value="3-5x per minggu">3–5x per minggu</Option>
                                            <Option value="Weekend">Weekend</Option>
                                            <Option value="Musiman">Musiman</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Estimasi Penumpang Per Hari di Rute Ini *</i>
                                        <InputNumber 
                                            value={this.state.estimasiPenumpangPerHari} 
                                            onChange={value => this.onFieldChange("estimasiPenumpangPerHari", value)} 
                                            placeholder="Jumlah penumpang"
                                            min={1}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row style={{marginBottom: '15px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Jam Favorit Operasional *</i>
                                </Col>
                                <Col xl={{span: 6}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jamFavoritPagi', e.target.checked)} 
                                        checked={this.state.jamFavoritPagi}
                                    >
                                        Pagi
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 6}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jamFavoritSiang', e.target.checked)} 
                                        checked={this.state.jamFavoritSiang}
                                    >
                                        Siang
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 6}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jamFavoritSore', e.target.checked)} 
                                        checked={this.state.jamFavoritSore}
                                    >
                                        Sore
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 6}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('jamFavoritMalam', e.target.checked)} 
                                        checked={this.state.jamFavoritMalam}
                                    >
                                        Malam
                                    </Checkbox>
                                </Col>
                            </Row>

                            {/* D. Minat & Model Kerja Sama Limo Green */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>D. Minat & Model Kerja Sama Limo Green</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 24}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginBottom: 20}}>
                                    <i className={`text-small-grey-nopadding`}>Tingkat Minat Mencoba Limo Green (1-5)</i>
                                    <div style={{padding: '10px 20px'}}>
                                        <Slider
                                            min={1}
                                            max={5}
                                            value={this.state.tingkatMinat}
                                            onChange={value => this.onFieldChange("tingkatMinat", value)}
                                            marks={{
                                                1: '1',
                                                2: '2',
                                                3: '3',
                                                4: '4',
                                                5: '5'
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Target Kebutuhan Unit Untuk Rute Ini *</i>
                                        <Select
                                            value={this.state.targetKebutuhanUnit}
                                            onChange={value => this.onFieldChange("targetKebutuhanUnit", value)}
                                            placeholder="Pilih target unit"
                                            style={{width: '100%'}}
                                        >
                                            <Option value="1-2">1–2 unit</Option>
                                            <Option value="3-5">3–5 unit</Option>
                                            <Option value="6-10">6–10 unit</Option>
                                            <Option value=">10">&gt;10 unit</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Waktu Mulai Operasional *</i>
                                        <Select
                                            value={this.state.waktuMulaiOperasional}
                                            onChange={value => this.onFieldChange("waktuMulaiOperasional", value)}
                                            placeholder="Pilih waktu"
                                            style={{width: '100%'}}
                                        >
                                            <Option value="<1 bulan">&lt;1 bulan</Option>
                                            <Option value="1-3 bulan">1–3 bulan</Option>
                                            <Option value="3-6 bulan">3–6 bulan</Option>
                                            <Option value=">6 bulan">&gt;6 bulan</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Preferensi Skema *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("preferensiSkema", e.target.value)} 
                                            value={this.state.preferensiSkema}
                                        >
                                            <Space direction="vertical">
                                                <Radio value="Sewa harian">Sewa harian</Radio>
                                                <Radio value="Sewa bulanan">Sewa bulanan</Radio>
                                                <Radio value="Rent-to-own (sewa beli)">Rent-to-own (sewa beli)</Radio>
                                                <Radio value="Beli unit (tunai/kredit)">Beli unit (tunai/kredit)</Radio>
                                                <Radio value="Masih eksplorasi">Masih eksplorasi</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>

                            {/* E. Ekonomi & Preferensi Harga */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>E. Ekonomi & Preferensi Harga</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Harga Tiket Rata-rata Saat Ini (per pax) *</i>
                                        <InputNumber 
                                            value={this.state.hargaTiketRataRata} 
                                            onChange={value => this.onFieldChange("hargaTiketRataRata", value)} 
                                            placeholder="Masukan harga dalam Rupiah"
                                            min={0}
                                            formatter={value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value!.replace(/Rp\s?|(,*)/g, '')}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Range Harga Tiket yang Realistis untuk EV Premium *</i>
                                        <Select
                                            value={this.state.rangeHargaTiketEV}
                                            onChange={value => this.onFieldChange("rangeHargaTiketEV", value)}
                                            placeholder="Pilih range"
                                            style={{width: '100%'}}
                                        >
                                            <Option value="+0%">+0% (sama dengan sekarang)</Option>
                                            <Option value="+5-10%">+5–10%</Option>
                                            <Option value="+10-20%">+10–20%</Option>
                                            <Option value=">20%">&gt;20%</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Biaya BBM Per Bulan Per Unit Saat Ini (Opsional)</i>
                                        <InputNumber 
                                            value={this.state.biayaBBMPerBulan} 
                                            onChange={value => this.onFieldChange("biayaBBMPerBulan", value)} 
                                            placeholder="Masukan biaya dalam Rupiah"
                                            min={0}
                                            formatter={value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value!.replace(/Rp\s?|(,*)/g, '')}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row style={{marginBottom: '15px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Masalah Biaya Terbesar Saat Ini</i>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('masalahBiayaBBM', e.target.checked)} 
                                        checked={this.state.masalahBiayaBBM}
                                    >
                                        BBM
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('masalahBiayaPerawatan', e.target.checked)} 
                                        checked={this.state.masalahBiayaPerawatan}
                                    >
                                        Perawatan
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('masalahBiayaSupir', e.target.checked)} 
                                        checked={this.state.masalahBiayaSupir}
                                    >
                                        Supir
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('masalahBiayaDowntime', e.target.checked)} 
                                        checked={this.state.masalahBiayaDowntime}
                                    >
                                        Downtime
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('masalahBiayaKomisiPlatform', e.target.checked)} 
                                        checked={this.state.masalahBiayaKomisiPlatform}
                                    >
                                        Komisi Platform
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('masalahBiayaLainnya', e.target.checked)} 
                                        checked={this.state.masalahBiayaLainnya}
                                    >
                                        Lainnya
                                    </Checkbox>
                                </Col>
                            </Row>

                            {/* F. Infrastruktur & Kesiapan EV */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>F. Infrastruktur & Kesiapan EV</span>
                            </Divider>
                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Punya Akses Charging? *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("aksesCharging", e.target.value)} 
                                            value={this.state.aksesCharging}
                                        >
                                            <Radio value="Ya">Ya</Radio>
                                            <Radio value="Tidak">Tidak</Radio>
                                            <Radio value="Bisa kerja sama">Bisa kerja sama</Radio>
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>

                            {this.state.aksesCharging === "Ya" && (
                                <Row style={{marginBottom: '15px'}}>
                                    <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                        <i className={`text-small-grey-nopadding`}>Jenis Charging *</i>
                                    </Col>
                                    <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Checkbox 
                                            onChange={e => this.onCheckboxChange('jenisChargingRumah', e.target.checked)} 
                                            checked={this.state.jenisChargingRumah}
                                        >
                                            Rumah
                                        </Checkbox>
                                    </Col>
                                    <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Checkbox 
                                            onChange={e => this.onCheckboxChange('jenisChargingDepotPool', e.target.checked)} 
                                            checked={this.state.jenisChargingDepotPool}
                                        >
                                            Depot/Pool
                                        </Checkbox>
                                    </Col>
                                    <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Checkbox 
                                            onChange={e => this.onCheckboxChange('jenisChargingPublic', e.target.checked)} 
                                            checked={this.state.jenisChargingPublic}
                                        >
                                            Public Charging
                                        </Checkbox>
                                    </Col>
                                </Row>
                            )}

                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Lokasi Pool Utama *</i>
                                        <Input 
                                            value={this.state.lokasiPoolUtama} 
                                            onChange={event => this.onFieldChange("lokasiPoolUtama", event.target.value)} 
                                            placeholder="Alamat atau area pool utama"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row style={{marginBottom: '15px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Kendala Utama Untuk EV</i>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaCharging', e.target.checked)} 
                                        checked={this.state.kendalaCharging}
                                    >
                                        Charging
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaDurasiCharge', e.target.checked)} 
                                        checked={this.state.kendalaDurasiCharge}
                                    >
                                        Durasi charge
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaRange', e.target.checked)} 
                                        checked={this.state.kendalaRange}
                                    >
                                        Range
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaResaleValue', e.target.checked)} 
                                        checked={this.state.kendalaResaleValue}
                                    >
                                        Resale value
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaMaintenance', e.target.checked)} 
                                        checked={this.state.kendalaMaintenance}
                                    >
                                        Maintenance & sparepart
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaPembiayaan', e.target.checked)} 
                                        checked={this.state.kendalaPembiayaan}
                                    >
                                        Pembiayaan
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaEdukasiDriver', e.target.checked)} 
                                        checked={this.state.kendalaEdukasiDriver}
                                    >
                                        Edukasi driver
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('kendalaLainnya', e.target.checked)} 
                                        checked={this.state.kendalaLainnya}
                                    >
                                        Lainnya
                                    </Checkbox>
                                </Col>
                                {this.state.kendalaLainnya && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Input 
                                            value={this.state.kendalaLainnyaText} 
                                            onChange={event => this.onFieldChange("kendalaLainnyaText", event.target.value)} 
                                            placeholder="Sebutkan kendala lainnya"
                                            style={{width: '100%'}}
                                        />
                                    </Col>
                                )}
                            </Row>

                            {/* G. Lead Qualification */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>G. Lead Qualification</span>
                            </Divider>
                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Apakah Anda open untuk dihubungi tim kami via WA untuk simulasi unit economics? *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("openDihubungi", e.target.value)} 
                                            value={this.state.openDihubungi}
                                        >
                                            <Radio value="Ya">Ya</Radio>
                                            <Radio value="Tidak">Tidak</Radio>
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>

                            {this.state.openDihubungi === "Ya" && (
                                <Row>
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                        <Form.Item style={formItemStyle}>
                                            <i className={`text-small-grey-nopadding`}>Waktu Terbaik Dihubungi *</i>
                                            <Select
                                                value={this.state.waktuTerbaikDihubungi}
                                                onChange={value => this.onFieldChange("waktuTerbaikDihubungi", value)}
                                                placeholder="Pilih waktu"
                                                style={{width: '100%'}}
                                            >
                                                <Option value="Pagi (08:00-11:00)">Pagi (08:00-11:00)</Option>
                                                <Option value="Siang (11:00-14:00)">Siang (11:00-14:00)</Option>
                                                <Option value="Sore (14:00-17:00)">Sore (14:00-17:00)</Option>
                                                <Option value="Malam (17:00-20:00)">Malam (17:00-20:00)</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            )}

                            <Row>
                                <Col xl={{span: 24}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Catatan Kebutuhan Khusus (Opsional)</i>
                                        <TextArea 
                                            value={this.state.catatanKhusus} 
                                            onChange={event => this.onFieldChange("catatanKhusus", event.target.value)} 
                                            placeholder="Tuliskan kebutuhan atau pertanyaan khusus Anda..."
                                            rows={4}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* H. CTA & Consent */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>H. Persetujuan</span>
                            </Divider>
                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('consentSetuju', e.target.checked)} 
                                        checked={this.state.consentSetuju}
                                    >
                                        <span style={{fontWeight: 500}}>
                                            Saya setuju data saya digunakan untuk dihubungi terkait penawaran & simulasi. *
                                        </span>
                                    </Checkbox>
                                </Col>
                            </Row>

                            <Divider />
                            
                            <Button 
                                onClick={this.onSubmitForm} 
                                loading={this.state.isSubmitting} 
                                style={{backgroundColor: '#384967', width: "220px", borderColor: '#384967', color: '#fff', height: '45px', fontSize: '15px'}} 
                                danger
                            >
                                Kirim & Minta Simulasi Rute
                            </Button>
                        </Form>
                    </Col>
                </Row>

                <div style={{minHeight: 100}}/>
                <FooterSection/>
            </>
        );
    }
}
export default withRouter(FormGreenTravel);